import { Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { WireInstructionsLoanDetailsCard } from './wireInstructionsLoanDetailsCard';
import { WireInstructionsStore } from '../stores/wireInstructionsStore';

const useStyles = makeStyles((theme: Theme) => ({
  leftColumn: {
    padding: theme.spacing(8, 6),
  },
  rightColumn: {
    padding: theme.spacing(8, 6),
  },
  thankYou: {
    ...theme.typography.h4,
    fontSize: 48,
  },
  text: {
    padding: theme.spacing(4, 0),
  },
}));

interface Props {
  store: WireInstructionsStore;
}

export const SummaryStep = observer(({ store }: Props) => {
  const classes = useStyles();
  const { loanData } = store;

  return (
    <Grid container>
      <Grid item md={12} lg={6} className={classes.leftColumn}>
        <Typography className={classes.thankYou}>
          Thank you{loanData?.contactName ? `, ${loanData.contactName}` : ''}!
        </Typography>
        <Typography className={classes.text}>
          Your wire instructions have been submitted. Our closing team will review
          the information and reach out if anything is needed.
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={6} className={classes.rightColumn}>
        <WireInstructionsLoanDetailsCard loanData={loanData} />
      </Grid>
    </Grid>
  );
});
